//import React components
import SideControlInfo from "./components/SideControlInfo";
import SideControlActions from "./components/SideControlActions";
import React, {useRef} from "react";
import {useSettingStore} from "../../../context/settings";

//import components


//Props settings for sideControl
type props = {}

const SideControl: React.FC<props> = () => {
  const userbarExtended = useSettingStore((state) => state.userbarExtended);

  const sideMenuRef = useRef(null);

  return (
    <>
      <div className={userbarExtended ? "sideControl--open" : "sideControl"} ref={sideMenuRef}>
        <div className={"sideControl_container"}>
          <SideControlInfo/>
          <SideControlActions/>
        </div>
      </div>
    </>
  )
}

export default SideControl;
